import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FarmHarvestRewardsCard = _resolveComponent("FarmHarvestRewardsCard")!

  return (_openBlock(), _createBlock(_component_FarmHarvestRewardsCard, {
    "farm-id": _ctx.pool.decoratedFarm.id,
    "token-address": _ctx.pool.address,
    "has-embr-rewards": _ctx.pool.decoratedFarm.rewards > 0,
    "has-third-party-rewards": _ctx.pool.decoratedFarm.rewardTokenPerDay > 0,
    "pending-embr": _ctx.pool.decoratedFarm.pendingWAVE,
    "pending-embr-value": _ctx.pool.decoratedFarm.pendingWAVEValue
  }, null, 8, ["farm-id", "token-address", "has-embr-rewards", "has-third-party-rewards", "pending-embr", "pending-embr-value"]))
}